import moment from 'moment'

const strToDate = (str?: string | null): Date | null => {
    if (!str) {
        return null
    }

    return moment(str, moment.ISO_8601).toDate()
}

export default strToDate
